import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "15.5",
      fill: "#F5FAFF",
      stroke: "#83B9FF",
      "stroke-dasharray": "4 4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M21.253 21.96c-.633.467-1.466.707-2.46.707h-5.586q-.242.002-.474-.027l4.6-4.6zm1.414-8.753v5.586c0 .994-.24 1.827-.707 2.46l-3.92-3.92 4.6-4.6q.029.232.027.474",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "m18.04 17.333 3.92 3.92q-.288.419-.707.707l-3.92-3.92-4.6 4.6a4 4 0 0 1-1.166-.247c-1.427-.52-2.234-1.786-2.234-3.6v-5.586c0-2.427 1.447-3.874 3.874-3.874h5.586c1.814 0 3.08.807 3.6 2.234.134.353.22.74.247 1.166z",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "m18.04 17.333 3.92 3.92a2.7 2.7 0 0 1-.707.707l-3.92-3.92-4.6 4.6a4 4 0 0 1-1.166-.247l.26-.26 10.566-10.566c.134.353.22.74.247 1.166zm-1.88-4.046c-.253-1.1-1.227-1.594-2.08-1.6-.853 0-1.826.493-2.08 1.593-.28 1.22.467 2.24 1.14 2.88a1.375 1.375 0 0 0 1.88 0c.674-.64 1.42-1.66 1.14-2.873m-2.06 1.04a.67.67 0 0 1-.667-.667c0-.367.294-.667.667-.667h.007c.367 0 .667.3.667.667a.674.674 0 0 1-.674.667"
    }, null, -1)
  ]))]))
}
export default { render: render }